// FREE PROVIDER CREDENTIALS FOR CAREER GPS AI
// Only include credentials where the provider offers the credential
// without charging the learner for the credential itself.

export const FREE_CERTIFICATIONS = [
  {
    id: "hubspot-digital-marketing",
    name: "Digital Marketing Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    difficulty: "Beginner",
    credentialType: "Free Certificate",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Learn the fundamentals of digital marketing and earn a free HubSpot Academy certificate.",
    skills: [
      "Digital Marketing",
      "SEO",
      "Content Marketing",
      "Social Media",
      "Email Marketing",
    ],
    careerPaths: [
      "Digital Marketing Specialist",
      "Marketing Executive",
      "SEO Specialist",
      "Social Media Manager",
    ],
    officialUrl: "https://academy.hubspot.com/courses/digital-marketing",
  },

  {
    id: "hubspot-social-media",
    name: "Social Media Marketing Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    difficulty: "Beginner",
    credentialType: "Free Certificate",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Learn social media marketing strategy, content and campaign management and earn a free certificate.",
    skills: [
      "Social Media Marketing",
      "Content Strategy",
      "Social Campaigns",
      "Analytics",
    ],
    careerPaths: [
      "Social Media Manager",
      "Marketing Specialist",
      "Digital Marketer",
    ],
    officialUrl: "https://academy.hubspot.com/courses/social-media",
  },

  {
    id: "hubspot-content-marketing",
    name: "Content Marketing Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    difficulty: "Beginner",
    credentialType: "Free Certificate",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Build practical content marketing skills and earn a free HubSpot Academy certificate.",
    skills: [
      "Content Marketing",
      "Content Strategy",
      "Storytelling",
      "SEO",
    ],
    careerPaths: [
      "Content Writer",
      "Content Marketer",
      "Marketing Specialist",
    ],
    officialUrl: "https://academy.hubspot.com/courses/content-marketing",
  },

  {
    id: "hubspot-inbound",
    name: "Inbound Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    difficulty: "Beginner",
    credentialType: "Free Certificate",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Learn inbound marketing and customer-focused growth strategies and earn a free certificate.",
    skills: [
      "Inbound Marketing",
      "Customer Journey",
      "Lead Generation",
      "Content",
    ],
    careerPaths: [
      "Marketing Specialist",
      "Growth Marketer",
      "Digital Marketer",
    ],
    officialUrl: "https://academy.hubspot.com/courses/inbound",
  },

  {
    id: "hubspot-inbound-sales",
    name: "Inbound Sales Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    difficulty: "Beginner",
    credentialType: "Free Certificate",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Learn modern inbound sales techniques and earn a free HubSpot Academy certificate.",
    skills: [
      "Inbound Sales",
      "Prospecting",
      "Lead Qualification",
      "Sales Process",
    ],
    careerPaths: [
      "Sales Executive",
      "Sales Representative",
      "Business Development Executive",
    ],
    officialUrl: "https://academy.hubspot.com/courses/inbound-sales",
  },

  {
    id: "hubspot-service-hub",
    name: "Service Hub Software Certification",
    provider: "HubSpot",
    category: "Customer Service",
    difficulty: "Beginner",
    credentialType: "Free Certificate",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Learn customer service workflows and Service Hub tools while earning a free provider certificate.",
    skills: [
      "Customer Service",
      "CRM",
      "Help Desk",
      "Customer Success",
    ],
    careerPaths: [
      "Customer Support Specialist",
      "Customer Success Manager",
      "Service Representative",
    ],
    officialUrl: "https://academy.hubspot.com/courses/service-hub-software",
  },

  {
    id: "hubspot-sales-hub",
    name: "HubSpot Sales Hub Software Certification",
    provider: "HubSpot",
    category: "Marketing & Sales",
    difficulty: "Beginner",
    credentialType: "Free Certificate",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Learn how to use Sales Hub tools and workflows and earn a free provider certificate.",
    skills: [
      "CRM",
      "Sales Hub",
      "Pipeline Management",
      "Sales Reporting",
    ],
    careerPaths: [
      "Sales Representative",
      "Sales Operations Specialist",
      "Business Development Executive",
    ],
    officialUrl: "https://academy.hubspot.com/courses/sales-software",
  },

  {
    id: "aws-cloud-quest",
    name: "AWS Cloud Quest: Cloud Practitioner",
    provider: "AWS",
    category: "Cloud & DevOps",
    difficulty: "Beginner",
    credentialType: "Digital Badge",
    cost: "Free tier available",
    duration: "Self-paced",
    description:
      "Build foundational AWS cloud skills through an interactive learning experience and earn an AWS digital badge when the applicable free requirements are completed.",
    skills: [
      "AWS",
      "Cloud Computing",
      "Cloud Concepts",
      "Security",
      "Core Services",
    ],
    careerPaths: [
      "Cloud Support",
      "IT Support",
      "Cloud Engineer",
      "Cloud Administrator",
    ],
    officialUrl: "https://aws.amazon.com/training/digital/aws-cloud-quest/",
  },

  {
    id: "aws-generative-ai-fundamentals",
    name: "Generative AI Fundamentals",
    provider: "AWS",
    category: "AI & Machine Learning",
    difficulty: "Beginner",
    credentialType: "Digital Credential",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Learn foundational generative AI concepts through AWS training and earn the applicable AWS digital credential.",
    skills: [
      "Generative AI",
      "AI Fundamentals",
      "Machine Learning",
      "AWS",
    ],
    careerPaths: [
      "AI Analyst",
      "AI Product Specialist",
      "Cloud Analyst",
      "Business Analyst",
    ],
    officialUrl: "https://aws.amazon.com/training/",
  },

  {
    id: "google-cloud-genai",
    name: "Generative AI Fundamentals Skill Badge",
    provider: "Google Cloud",
    category: "AI & Machine Learning",
    difficulty: "Beginner",
    credentialType: "Skill Badge",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Complete Google Cloud learning activities covering generative AI fundamentals and earn a Google-verified skill badge.",
    skills: [
      "Generative AI",
      "AI Fundamentals",
      "Google Cloud",
      "Machine Learning",
    ],
    careerPaths: [
      "AI Analyst",
      "Cloud Analyst",
      "AI Product Specialist",
      "Data Analyst",
    ],
    officialUrl:
      "https://cloud.google.com/blog/products/ai-machine-learning/google-cloud-generative-ai-skill-badge",
  },

  {
    id: "openlearn-digital-skills",
    name: "Digital Skills: Succeeding in a Digital World",
    provider: "OpenLearn",
    category: "IT & Digital Skills",
    difficulty: "Beginner",
    credentialType: "Statement of Participation",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Develop practical digital skills and receive a free OpenLearn Statement of Participation after completing the course.",
    skills: [
      "Digital Skills",
      "Communication",
      "Online Research",
      "Digital Literacy",
    ],
    careerPaths: [
      "IT Support",
      "Business Professional",
      "Administrator",
      "Digital Skills Specialist",
    ],
    officialUrl:
      "https://www.open.edu/openlearn/badged-courses",
  },

  {
    id: "openlearn-project-management",
    name: "Project Management Fundamentals",
    provider: "OpenLearn",
    category: "Project & Business Management",
    difficulty: "Beginner",
    credentialType: "Statement of Participation",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Study foundational project management concepts through OpenLearn and receive the applicable free completion statement.",
    skills: [
      "Project Management",
      "Planning",
      "Risk",
      "Teamwork",
      "Project Delivery",
    ],
    careerPaths: [
      "Project Coordinator",
      "Project Manager",
      "Project Administrator",
      "BIM Coordinator",
    ],
    officialUrl:
      "https://www.open.edu/openlearn/badged-courses",
  },

  {
    id: "openlearn-business",
    name: "Business and Management Free Badged Courses",
    provider: "OpenLearn",
    category: "Business Management",
    difficulty: "Beginner",
    credentialType: "Digital Badge",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Explore free business and management learning opportunities with eligible OpenLearn courses offering digital badges.",
    skills: [
      "Business",
      "Management",
      "Leadership",
      "Decision Making",
      "Communication",
    ],
    careerPaths: [
      "Business Analyst",
      "Business Manager",
      "Team Leader",
      "Project Manager",
    ],
    officialUrl:
      "https://www.open.edu/openlearn/badged-courses",
  },

  {
    id: "openlearn-healthcare",
    name: "Healthcare & Health Free Learning Credentials",
    provider: "OpenLearn",
    category: "Healthcare",
    difficulty: "Beginner",
    credentialType: "Statement of Participation",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Access free healthcare and health-related courses and receive the applicable OpenLearn completion statement.",
    skills: [
      "Healthcare",
      "Health Education",
      "Public Health",
      "Communication",
    ],
    careerPaths: [
      "Healthcare Assistant",
      "Healthcare Administrator",
      "Public Health Professional",
      "Nursing Student",
    ],
    officialUrl:
      "https://www.open.edu/openlearn/badged-courses",
  },

  {
    id: "openlearn-education",
    name: "Education & Teaching Free Badged Courses",
    provider: "OpenLearn",
    category: "Education",
    difficulty: "Beginner",
    credentialType: "Digital Badge",
    cost: "Free",
    duration: "Self-paced",
    description:
      "Develop teaching and education skills through eligible OpenLearn courses with free digital credentials.",
    skills: [
      "Teaching",
      "Education",
      "Learning Design",
      "Digital Education",
    ],
    careerPaths: [
      "Teacher",
      "Teaching Assistant",
      "Instructional Designer",
      "Education Professional",
    ],
    officialUrl:
      "https://www.open.edu/openlearn/badged-courses",
  },
];
